import dayjs from 'dayjs';

export const isDueToday = (expirationDate: string | null): boolean => {
  if (!expirationDate) {
    return false;
  }
  return dayjs(expirationDate).isSame(dayjs(), 'day');
};

export const isOverdue = (expirationDate: string | null): boolean => {
  if (!expirationDate) {
    return false;
  }
  return dayjs(expirationDate).isBefore(dayjs(), 'day');
};
